var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import VolunteerServiceContext, { VOLUNTEER_ERROR, } from '../../volunteer-service/VolunteerServiceContext';
import { useCallback, useContext } from 'react';
import useAsync from '../../hooks/UseAsync';
import VolunteerForm from './VolunteerForm';
import useForm from '../../hooks/UseForm';
import PhraseContext from '../../phrase/PhraseContextInterface';
import { capitalizeName } from '../../util/capitalize';
const AsyncForm = ({ volunteer }) => {
    const { phrase } = useContext(PhraseContext);
    const { registerVolunteer } = useContext(VolunteerServiceContext);
    const register = (i) => registerVolunteer(i).catch((e) => {
        var _a, _b, _c;
        throw new Error((_c = (_b = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : e.message);
    });
    const inspect = useAsync(() => __awaiter(void 0, void 0, void 0, function* () { return volunteer; }), 'loading');
    const { formState: { phone, email, newsletter }, handleChange, } = useForm({
        initialState: volunteer,
    });
    return inspect({
        pending: (state) => ({
            loading: () => _jsx("span", { children: "Loading" }),
            saving: () => (_jsx(VolunteerForm, { handleChange: handleChange, volunteer: Object.assign(Object.assign({}, volunteer), { phone, email, newsletter }), onSubmit: (_) => null, isLoading: true })),
        }[state]()),
        resolved: (volunteerData, state, update) => {
            var _a;
            return ({
                showForm: () => (_jsx(VolunteerForm, { handleChange: handleChange, volunteer: Object.assign(Object.assign({}, volunteerData), { phone, email, newsletter }), onSubmit: (input) => update(register(input), 'saving') })),
                isSubmitted: () => (_jsx(VolunteerForm, { handleChange: handleChange, volunteer: Object.assign(Object.assign({}, volunteerData), { phone, email, newsletter }), onSubmit: (input) => update(register(input), 'saving'), isSubmitted: true, message: phrase('success_text', 'Thank you! We will get in touch with you as soon as possible') })),
            }[((_a = volunteerData === null || volunteerData === void 0 ? void 0 : volunteerData.status) === null || _a === void 0 ? void 0 : _a.length) && volunteerData.status.length > 0
                ? 'isSubmitted'
                : 'showForm']());
        },
        rejected: (err, state, update) => (_jsx(VolunteerForm, { handleChange: handleChange, volunteer: Object.assign(Object.assign({}, volunteer), { phone, email, newsletter }), onSubmit: (input) => update(register(input), 'saving'), hasError: true, message: err.message })),
    });
};
function RegisterVolunteer() {
    const { getVolunteer } = useContext(VolunteerServiceContext);
    const getVolunteerWithNullCatch = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        return getVolunteer().catch((e) => {
            const { name } = e;
            if (!name || name !== VOLUNTEER_ERROR.VOLUNTEER_DOES_NOT_EXIST)
                throw e;
            return window.gdiHost.getAccessToken().then(({ decoded }) => ({
                id: decoded.id,
                firstName: capitalizeName(decoded.firstName),
                lastName: capitalizeName(decoded.lastName),
                email: '',
                phone: '',
                status: '',
                newsletter: undefined,
            }));
        });
    }), []);
    const inspect = useAsync(getVolunteerWithNullCatch, 'loading');
    return inspect({
        pending: (_state) => _jsx("span", { children: "pending" }),
        resolved: (volunteer, state, _update) => _jsx(AsyncForm, { volunteer: volunteer }),
        rejected: (_err, _state, _update) => _jsx("span", { children: "rejected" }),
    });
}
export default RegisterVolunteer;
